import React from 'react';
import { Button } from '@material-ui/core';
import { Launch } from '@material-ui/icons';
import { useTranslation } from 'react-i18next';

import { useSquareOrders } from '../../hooks/useSquareExternal';

export interface ISquareLink {
    squareOrderId: string;
}

const SquareLink = (props: ISquareLink) => {
    const { t } = useTranslation();
    const { squareUrl } = useSquareOrders(props.squareOrderId);
    return (
        <a style={{textDecoration: "none"}} href={squareUrl} target="_blank" rel="noopener noreferrer">
            <Button
                variant="contained"
            >
                <Launch style={{margin: "0 0.5rem"}} />
                {t("orderHistory.modal.openSquare")}
            </Button>
        </a>
        
    )
}

export default SquareLink;